import React from 'react';
import './styles.scss';

import logo from './img/logo.svg';

const Logo = () => (
  <div className="logo-body">
    <img className="logoimg" src={logo} alt="Logo" />
    <br />
    <p className="login-caption" >Sign in to <br /> Instant Cars Loan Approval.</p>
    <p className="login-prompt">Enter your credentials below.</p>
  </div>
);
export default Logo;



// WEBPACK FOOTER //
// ./src/pages/LoginAdmin/commponents/Logo/index.js